import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Ecosystem" },
  { to: "/growth-consulting", label: "Growth" },
  { to: "/saas", label: "Deployedd Digital" },
  { to: "/built-at-labs", label: "Built at Labs" },
  { to: "/pulse", label: "Pulse" },
  { to: "/blog", label: "Journal" },
  { to: "/about", label: "About" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "backdrop-blur-xl bg-white/75 border-b border-black/10" : "bg-transparent"
      }`}
    >
      <div className="container-wide flex items-center justify-between h-16 md:h-20">
        <Link to="/" data-testid="navbar-logo" className="flex items-center gap-3 group">
          <span className="inline-flex items-center justify-center bg-white p-1.5 md:p-2 border border-black/10 shadow-sm">
            <img
              src="https://customer-assets.emergentagent.com/job_deployedd-labs/artifacts/glgihy7l_Deployed%20Logo-01.png"
              alt="Deployedd Labs"
              width="48"
              height="48"
              className="h-9 md:h-11 w-auto object-contain"
            />
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`nav-link-${item.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `link-underline text-[12px] uppercase tracking-[0.2em] font-medium transition-colors ${
                  isActive ? "text-[#9F381A]" : "text-ink hover:text-[#9F381A]"
                }`
              }
              end={item.to === "/"}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <Link
          to="/contact"
          data-testid="navbar-cta-contact"
          className="hidden md:inline-flex items-center gap-2 bg-[#0A0A0A] text-white px-5 py-2.5 text-[11px] uppercase tracking-[0.2em] hover:bg-[#9F381A] transition-colors duration-300"
        >
          Contact <ArrowUpRight className="w-3.5 h-3.5" />
        </Link>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden p-2 -mr-2"
          aria-label="Toggle menu"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-white border-t border-black/10">
          <div className="container-wide py-6 flex flex-col gap-4">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                data-testid={`mobile-nav-link-${item.label.toLowerCase().replace(/\s/g, "-")}`}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `text-sm uppercase tracking-[0.2em] py-2 ${isActive ? "text-[#9F381A]" : "text-ink"}`
                }
                end={item.to === "/"}
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              data-testid="mobile-nav-contact-cta"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-between bg-[#0A0A0A] text-white px-5 py-3 text-xs uppercase tracking-[0.2em]"
            >
              Contact us <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
